<template>
  <div class="imgBox">
       <el-upload
        action=""
        :auto-upload=false
        :multiple=true
        :file-list="imgList"
        :on-change="imgPreview"
        list-type="picture-card"
        accept="image/*"
        :limit="20"
        :disabled="delFlag"
        drag
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove" :class="[isAdd?'hidden':'']">
      </el-upload>
      <span style="font-size:12px" v-if="max>1">最多上传{{max}}张，支持jpg、png格式图片</span>
      <el-dialog  title="图片展示" :visible.sync="dialogVisible" append-to-body center width="1100px" class="imgDialog">
        <img style="max-width:100%;" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'uploadImgs',
  props: {
    imgList: {
      type: Array,
      default: function () {
        return []
      }
    },
    max: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      delFlag: false

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.imgList.length == this.max) {
      this.isAdd = true
    }
  },
  methods: {
    // 图片上传
    handleRemove (file, fileList) {
      this.$emit('update:imgList', fileList)
      this.$emit('remove', file)
      if (fileList.length < this.max) {
        this.isAdd = false
      }
    },

    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        this.$emit('update:imgList', fileList)
        this.$emit('change', fileList)
        if (fileList.length < this.max) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.imgBox{
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card{
  display: none;
}
.imgDialog /deep/.el-dialog__body{
  text-align: center;
}
</style>
